<template>
  <div
    :class="{'custom-input --horizontal': isHorizontal}"
    class="custom-input"
  >
    <label
      v-if="label"
    >{{ label }}</label>
    <div>
      <div>
        <input
          :type="type"
          :name="name"
          :placeholder="placeholder"
          :class="{inactive: !active, 'custom-input__alert': alert}"
          v-model="inputValue"
          @blur="handleBlur"
          @focus="handleFocus()"
        >
        <i
          v-if="svg && !loading"
          @click="clickOnSvg()"
          :class="{'custom-input__clickable': clickableSvg}"
        >
          <svg>
            <use :xlink:href="svg"></use>
          </svg>
        </i>
        <i v-if="loading">
          <svg
            version="1.1"
            id="loader-1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 50 50"
            style="enable-background: new 0 0 50 50;"
            xml:space="preserve"
          >
            <path
              fill="#000"
              d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"
            >
              <animateTransform
                attributeType="xml"
                attributeName="transform"
                type="rotate"
                from="0 25 25"
                to="360 25 25"
                dur="0.6s"
                repeatCount="indefinite"
              ></animateTransform>
            </path>
          </svg>
        </i>
      </div>
      <slot />
    </div>
  </div>
</template>

<script>
import debounce from 'lodash-es/debounce'

export default {
  name: 'SharedFetchEmail',
  props: {
    type: {
      type: String,
      default: 'text',
    },
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: 'email',
    },
    active: {
      type: Boolean,
      default: false,
    },
    alert: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    svg: {
      type: String,
      default: '',
    },
    clickableSvg: {
      type: Boolean,
      default: false,
    },
    list: {
      type: String,
      default: '',
    },
    error: {
      type: Boolean,
      default: false,
    },
    isHorizontal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      inputValue: '',
      itemToEmit: {
        name: null,
        value: null,
      },
    }
  },
  watch: {
    inputValue() {
      this.updateBooking()
    },
    value(val) {
      this.inputValue = val
    },
  },
  mounted() {
    this.inputValue = this.value
  },
  created() {
    this.updateBooking = debounce(this.debouncedAvailability, 500);
  },
  methods: {
    debouncedAvailability() {
      this.handleUserInput()
    },
    clickOnSvg() {
      this.$emit('click-on-svg', true)
    },
    handleFocus() {
      this.$emit('focus', true)
    },
    handleUserInput() {
      if (this.inputValue === undefined) return
      this.itemToEmit.name = this.list
      this.itemToEmit.value = this.inputValue
      return this.list
        ? this.$emit('fill-input', this.itemToEmit)
        : this.$emit('fill-input', this.inputValue)
    },
    handleBlur() {
      this.$emit('blur', this.inputValue)
    },
  },
}
</script>
<style scoped lang="scss">
@import '../../../../../_src/sass/config/vars';
@import '../../../../../_src/sass/config/mixins';
@import '../../../../../_src/sass/config/responsive';

.custom-input {
  align-items: stretch;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: flex-start;
  position: relative;

  &.--horizontal {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 25px 0;

    label {
      flex: 1;
    }

    div {
      flex: 1;
    }
  }

  svg {
    max-height: 15px;
    max-width: 15px;
    position: absolute;
    right: 10px;
    top: 15px;
    transform: translateY(-25%);
    z-index: 1;
  }

  &__clickable {
    cursor: pointer;
  }

  &__alert {
    @include alert;
  }

  div {
    display: flex;
    flex-direction: column;
    position: relative;
  }

  .error {
    display: flex;
    flex-direction: column;
    margin-top: 5px;
    text-align: left;
    width: 100%;

    span {
      @include errorInputs;
    }
  }

  .success {
    display: flex;
    flex-direction: column;
    margin-top: 5px;
    text-align: left;
    width: 100%;

    span {
      @include font-size(11);

      color: $c-eucalyptus;
      display: flex;
      flex: 1;
      font-family: $f-graphie-bold;
      justify-content: flex-start;
      width: 100%;
    }
  }
}

label {
  @include labels;

  .inscription & {
    margin: 0;
  }
}

input {
  @include sharable-input;

  width: 100%;

  .-large-text & {
    @include font-size(14px);

    font-family: $f-graphie-bold;
  }

  .-centered & {
    text-align: center;
  }
}
</style>
